import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

import { MdMenu as MenuIcon } from '@react-icons/all-files/md/MdMenu';
import Logo from '../components/Logo';
// ------------------------------------------------------------------------------------------

const TopHeader = (props) => 
{
  const [anchorElNav, setAnchorElNav] = useState(null);
  const navigate = useNavigate();

  const navigateTo = (url) => { 
    if ( url.includes('http://') || url.includes('https://') ) { 
        window.open( url, '_blank' );
    } else { 
        navigate(url);
    }
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: '#1F2F4C' }} >
        <Container maxWidth="xl">
            <Toolbar disableGutters>

                <Logo inverted sx={{ marginRight: '30px' }} />

                <Box sx={{ flexGrow: 1, display: 'flex' }} />
                
                { props?.minimal !== true && ( 
                  <>
                  { /* Mobile hamburger menu */ }
                  <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                      <IconButton size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleOpenNavMenu} color="inherit">
                          <MenuIcon />
                      </IconButton>
                      <Menu id="menu-appbar" anchorEl={anchorElNav} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} keepMounted
                          transformOrigin={{ vertical: 'top', horizontal: 'left' }} open={Boolean(anchorElNav)} onClose={handleCloseNavMenu}
                          sx={{
                              display: { xs: 'block', md: 'none' },
                          }}
                      >
                          <MenuItem onClick={ () => { navigateTo(`/write/${props?.companyID}`) }} >
                              <Typography textAlign="center">Leave a Review</Typography>
                          </MenuItem>
                          <MenuItem onClick={ () => { navigateTo('https://www.workingfeedback.co.uk') }} >
                              <Button variant="outlined">For Companies</Button>
                          </MenuItem>

                      </Menu>
                  </Box>

                  { /* Desktop menu */ }
                  <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                      <Button variant="text" onClick={ () => { navigateTo(`/write/gs/${props?.companyID}`) }} sx={{ my: 2, mr: 2, color: 'white', display: 'block' }}>Leave a Review</Button>
                      <Button variant="outlined" onClick={ () => { navigateTo('https://www.workingfeedback.co.uk') }} sx={{ my: 2, color: 'white', display: 'block' }}>For Companies</Button>
                  </Box>
                  </>
                )}                

        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default TopHeader;